import { SupportedCodeLang } from "../code-gen/code-lang.types";

interface BlocklyConfigState {
  codeLang: SupportedCodeLang;
  moduleKey: string;
  hideGatewayOption: boolean;
  isAdmin: boolean;
  isDirect: boolean;
}

enum DownloadTarget {
  Device = 'device',
  RaspberryPi = 'raspberry-pi',
  Script = 'script',
  Sketch = 'sketch',
}

interface DownloadOption {
  key: DownloadTarget;
  display: string;
}

type LangTargetsMap = Record<SupportedCodeLang, readonly DownloadTarget[]>;

type TargetMap<T> = Partial<Record<DownloadTarget, T>>;

type TargetLangsMap = TargetMap<readonly SupportedCodeLang[]>;

type TargetLabelsMap = TargetMap<string>;

type ModuleTargetOverrides = Record<string, Partial<LangTargetsMap>>;

export {
  BlocklyConfigState,
  DownloadTarget,
  DownloadOption,
  LangTargetsMap,
  TargetMap,
  TargetLangsMap,
  TargetLabelsMap,
  ModuleTargetOverrides,
};
